import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { EndOfWeekViewModel } from "./EndOfWeekViewModel";
import { SHBox } from "../../../../../Components/Box";
import { FireExitModel } from "./FireExitModel";
import { Uploader } from "../../../../../Components/Uploader/Uploader";
import { SectionSplitter } from "../../../../../Components/Form/SectionSplitter";
import { RadioAuditView } from "./EndOfWeekView";
import { FireExitViewModel } from "./FireExitViewModel";
import { EndOfWeekModel } from "./EndOfWeekModel";
import { IconButton, Typography } from "@material-ui/core";
import { uniqueId } from "lodash-es";
import { AuditDocumentModel } from "../AuditDocument";
import SystemUpdateTwoToneIcon from "@material-ui/icons/SystemUpdateTwoTone";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import { Step2Model } from "../../../../Induction/Step2/Step2Model";
import { DarwinInput } from "../../../../../Globals/Styles/Control/DarwinInput";
interface Props {
    index: number;
    fireExitViewModel: FireExitViewModel;
    endOfWeekViewModel: EndOfWeekViewModel;
}
export const FireExitView: React.FC<Props> = observer((props: Props) => {
    const { fireExitViewModel, endOfWeekViewModel } = props;

    return (
        <>
            <SHBox mt={2} key={uniqueId()}>
                <Typography variant={"h4"}>Fire Exit {props.index + 1}:</Typography>
                <SHBox grid dc={"262px"} mt={2} mb={2}>
                    <DarwinInput<FireExitViewModel>
                        type="text"
                        label="Location:"
                        placeholder="Please add"
                        validateOnBlur={false}
                        viewModel={fireExitViewModel}
                        fieldName={"location"}
                        shrink={true}
                        maxLength={4096}
                        editMode={endOfWeekViewModel.editable}
                    />
                </SHBox>
                <SHBox grid dc={"2fr 1fr"} mt={1}>
                    <RadioAuditView
                        title={"Signage over Ent/Ext"}
                        value={() => fireExitViewModel.getValue("signageOverEntExit")}
                        validationMessage={() => fireExitViewModel.getError("signageOverEntExit")}
                        onChange={(e) => fireExitViewModel.radioChanged(e, "signageOverEntExit", endOfWeekViewModel.editable)}
                        canExecute={endOfWeekViewModel.editable}
                    />
                    <SHBox dcs={"2"} showIf={fireExitViewModel.getValue("signageOverEntExit") === "no"}>
                        <DarwinInput<FireExitViewModel>
                            type="text"
                            label="Please give more details"
                            multiLine={true}
                            validateOnBlur={false}
                            viewModel={fireExitViewModel}
                            fieldName={"signageOverEntExitDetail"}
                            shrink={true}
                            maxLength={4096}
                            editMode={endOfWeekViewModel.editable}
                        />
                    </SHBox>
                    <RadioAuditView
                        title={"Doors working correctly (if applicable)"}
                        value={() => fireExitViewModel.getValue("doorsWorking")}
                        validationMessage={() => fireExitViewModel.getError("doorsWorking")}
                        onChange={(e) => fireExitViewModel.radioChanged(e, "doorsWorking", endOfWeekViewModel.editable)}
                        canExecute={endOfWeekViewModel.editable}
                    />
                    <SHBox dcs={"2"} showIf={fireExitViewModel.getValue("doorsWorking") === "no"}>
                        <DarwinInput<FireExitViewModel>
                            type="text"
                            label="Please give more details"
                            multiLine={true}
                            validateOnBlur={false}
                            viewModel={fireExitViewModel}
                            fieldName={"doorsWorkingDetail"}
                            shrink={true}
                            maxLength={4096}
                            editMode={endOfWeekViewModel.editable}
                        />
                    </SHBox>
                    <RadioAuditView
                        title={"Ent/Ext free from obstructions"}
                        value={() => fireExitViewModel.getValue("entExitFreeFromObstruction")}
                        validationMessage={() => fireExitViewModel.getError("entExitFreeFromObstruction")}
                        onChange={(e) => fireExitViewModel.radioChanged(e, "entExitFreeFromObstruction", endOfWeekViewModel.editable)}
                        canExecute={endOfWeekViewModel.editable}
                    />
                    <SHBox dcs={"2"} showIf={fireExitViewModel.getValue("entExitFreeFromObstruction") === "no"}>
                        <DarwinInput<FireExitViewModel>
                            type="text"
                            label="Please give more details"
                            multiLine={true}
                            validateOnBlur={false}
                            viewModel={fireExitViewModel}
                            fieldName={"entExitFreeFromObstructionDetail"}
                            shrink={true}
                            maxLength={4096}
                            editMode={endOfWeekViewModel.editable}
                        />
                    </SHBox>
                    <RadioAuditView
                        title={"Escape routes marked"}
                        value={() => fireExitViewModel.getValue("escapeRoutes")}
                        validationMessage={() => fireExitViewModel.getError("escapeRoutes")}
                        onChange={(e) => fireExitViewModel.radioChanged(e, "escapeRoutes", endOfWeekViewModel.editable)}
                        canExecute={endOfWeekViewModel.editable}
                    />
                    <SHBox dcs={"2"} showIf={fireExitViewModel.getValue("escapeRoutes") === "no"}>
                        <DarwinInput<FireExitViewModel>
                            type="text"
                            label="Please give more details"
                            multiLine={true}
                            validateOnBlur={false}
                            viewModel={fireExitViewModel}
                            fieldName={"escapeRoutesDetail"}
                            shrink={true}
                            maxLength={4096}
                            editMode={endOfWeekViewModel.editable}
                        />
                    </SHBox>
                    <RadioAuditView
                        title={"Adequate Lighting"}
                        value={() => fireExitViewModel.getValue("adequateLighting")}
                        validationMessage={() => fireExitViewModel.getError("adequateLighting")}
                        onChange={(e) => fireExitViewModel.radioChanged(e, "adequateLighting", endOfWeekViewModel.editable)}
                        canExecute={endOfWeekViewModel.editable}
                    />
                    <SHBox dcs={"2"} showIf={fireExitViewModel.getValue("adequateLighting") === "no"}>
                        <DarwinInput<FireExitViewModel>
                            type="text"
                            label="Please give more details"
                            multiLine={true}
                            validateOnBlur={false}
                            viewModel={fireExitViewModel}
                            fieldName={"adequateLightingDetail"}
                            shrink={true}
                            maxLength={4096}
                            editMode={endOfWeekViewModel.editable}
                        />
                    </SHBox>
                    <SHBox grid dc={"1fr"}>
                        <SHBox showIf={endOfWeekViewModel.editable}>
                            <Uploader
                                handleSelectFile={(e: React.ChangeEvent<HTMLInputElement>) => endOfWeekViewModel.fileChange(e, fireExitViewModel.model.auditDocuments)}
                                isFormDisabled={endOfWeekViewModel.IsLoading}
                                label="Audit documents (required)"
                            />
                            <Typography variant={"h5"} color={"error"}>
                                {fireExitViewModel.getError("auditDocuments")}
                            </Typography>
                        </SHBox>
                        <div className="uploadedFile">
                            {fireExitViewModel.model.auditDocuments &&
                                fireExitViewModel.model.auditDocuments.map((item: AuditDocumentModel, index: number) => {
                                    return (
                                        <div className="uploadedFile-box" key={uniqueId()}>
                                            <div className="uploadedFile-heading">
                                                <IconButton onClick={() => endOfWeekViewModel.DownloadFile(item.url, item.fileName)}>
                                                    <SystemUpdateTwoToneIcon />
                                                </IconButton>
                                                <h3>{item.fileName}</h3>
                                            </div>
                                            <IconButton onClick={() => item.deleteDocument()} disabled={false}>
                                                <DeleteOutlinedIcon />
                                            </IconButton>
                                        </div>
                                    );
                                })}
                        </div>
                    </SHBox>
                </SHBox>
                <SectionSplitter />
            </SHBox>
        </>
    );
});
